import React from 'react';
import { Icon, IconButton, makeStyles } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';


const GenericDeleteButton = (props) => {

    const {onDoubleClick} = props
    const classes = useStyles()

    return ( 
        <IconButton size='small' className={classes.edit_btn} onDoubleClick={onDoubleClick}>
            <Icon color='inherit' fontSize='small'>delete</Icon>
        </IconButton>
     );
}

const useStyles = makeStyles(theme => ({
    edit_btn:{
        color:grey[500],
        padding:4
    }
}))
 
export default GenericDeleteButton;